module.exports = __webpack_public_path__ + "img/outcome_01.21004a63.jpg";